__turbopack_context__.v({
  "root": "chat-loader-module-scss-module__PAyQzG__root",
});
